import axios from 'axios';
import { newUrl } from '../../utility';
import { SET_CENTER, SET_SELECTED_AREAS, SET_MARKER_DATA, SET_CITY_WARD_DATA } from './types';
import { fetchAndSetPoi } from './filterActions';

export const setCenterAction = center => dispatch=> {
    dispatch({
        type: SET_CENTER,
        payload : center
    })
}

export const setSelectedAreas = (selectedMapIcons, selectedAreas) => dispatch => {
    dispatch({
        type : SET_SELECTED_AREAS,
        payload : selectedAreas
    });

    fetchAndSetPoi(selectedMapIcons, selectedAreas, dispatch)
}

export const setMarkerData = (markerData)=> dispatch => {
    dispatch({
        type : SET_MARKER_DATA,
        payload : {}
    });

    const { _id } = markerData;

        axios.post(newUrl + "/get_site_details", {
            site_id: _id
        }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((result, error) => {
            if (error) {
                console.log(error);
            } else {
                if (result.data.result) {
                    dispatch({
                        type : SET_MARKER_DATA,
                        payload : result.data.result
                    });
                }
            }
        });
}

export const hideInfoBox = ()=> dispatch => {
    dispatch({
        type : SET_MARKER_DATA,
        payload : {}
    });
}


export const loadWardData =() => dispatch =>{
    axios.post(newUrl + "/getCityWardData", {

    }, { headers: { "authorization": localStorage.getItem("plano_token") } }).then((result, error) => {
        if (error) {
            console.log(error);
        } else {
            if (result.data) {
                console.log('')
                dispatch({
                    type : SET_CITY_WARD_DATA,
                    payload : result.data
                });
            }
        }
    });
}





// WEBPACK FOOTER //
// ./src/v3/actions/mapActions.js